module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats"
  }, [(_vm.deletingSellerId != null) ? _c('div', {
    staticClass: "ats-action-overlay",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "ats-loading"
  }, [_c('div', {
    staticClass: "ats-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "ats-error"
  }, [_c('p', {
    staticClass: "ats-error-title"
  }, [_vm._v("Could not load account settings")]), _vm._v(" "), _c('p', {
    staticClass: "ats-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("ACCOUNT OVERVIEW")]), _vm._v(" "), _c('div', {
    staticClass: "ats-overview-grid"
  }, [_c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("ACCOUNT OWNER")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_c('a', {
    staticClass: "ats-link",
    attrs: {
      "href": 'mailto:' + _vm.loginEmail
    }
  }, [_vm._v(_vm._s(_vm.loginEmail))])])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("PLAN")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.planName))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.planDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("CONNECTED STOREFRONTS")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.sellers.length))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.storefrontSummary))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("TEAM MEMBERS")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.teamUserAccounts.length))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.teamSummary))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-ov-card"
  }, [_c('span', {
    staticClass: "ats-ov-label"
  }, [_vm._v("ACCOUNT CREATED")]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-value"
  }, [_vm._v(_vm._s(_vm.accountCreatedDisplay))]), _vm._v(" "), _c('span', {
    staticClass: "ats-ov-sub"
  }, [_vm._v(_vm._s(_vm.billingCycleDisplay))])])]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("PROFILE")]), _vm._v(" "), _c('div', {
    staticClass: "ats-profile-row"
  }, [_c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("FIRST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("LAST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ats-field",
    staticStyle: {
      "max-width": "380px"
    }
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("LOGIN EMAIL")]), _vm._v(" "), _c('div', {
    staticClass: "ats-input ats-input-readonly"
  }, [_vm._v(_vm._s(_vm.loginEmail))])]), _vm._v(" "), _c('div', {
    staticClass: "ats-profile-actions"
  }, [_c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "ats-btn ats-btn-primary",
    class: {
      'ats-btn-loading': _vm.savingProfile
    },
    attrs: {
      "disabled": !_vm.profileDirty
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Save Changes")])]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("CONNECTED STOREFRONTS")]), _vm._v(" "), _c('div', {
    staticClass: "ats-card"
  }, [_c('div', {
    staticClass: "ats-card-header"
  }, [_vm._m(2), _vm._v(" "), (_vm.canAddStorefront) ? _c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.addStorefront
    }
  }, [_vm._v("+ Add Storefront")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ats-table-wrap"
  }, [_c('table', {
    staticClass: "ats-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SELLER ID")]), _vm._v(" "), _c('th', [_vm._v("NICKNAME")]), _vm._v(" "), _c('th', [_vm._v("REGION")]), _vm._v(" "), _c('th', [_vm._v("MARKETPLACES")]), _vm._v(" "), _c('th', [_vm._v("STATUS")]), _vm._v(" "), _c('th', {
    attrs: {
      "title": "Overrides per-alert storefront and brand settings."
    }
  }, [_vm._v("STOP ALL ALERTS")]), _vm._v(" "), (_vm.isOwner) ? _c('th', [_vm._v("ACTIONS")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.filteredSellers.length === 0) ? _c('tr', [_c('td', {
    staticClass: "ats-empty",
    attrs: {
      "colspan": _vm.isOwner ? 7 : 6
    }
  }, [_vm._v("No storefronts connected yet.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredSellers), function(seller) {
    return _c('tr', {
      key: _vm.sellerIdVal(seller)
    }, [_c('td', {
      staticClass: "ats-cell-mono"
    }, [_vm._v(_vm._s(_vm.sellerKeyVal(seller)))]), _vm._v(" "), _c('td', [(_vm.isOwner) ? _c('input', {
      staticClass: "ats-input ats-input-sm",
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "data-lpignore": "true",
        "spellcheck": "false"
      },
      domProps: {
        "value": _vm.sellerNicknameDisplay(seller)
      },
      on: {
        "input": function($event) {
          return _vm.onNickNameInput(seller, $event.target.value)
        }
      }
    }) : _c('span', {
      staticClass: "ats-cell-text"
    }, [_vm._v(_vm._s(_vm.sellerNicknameDisplay(seller) || '—'))])]), _vm._v(" "), _c('td', {
      staticClass: "ats-cell-center"
    }, [_vm._v(_vm._s(seller.region))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ats-mp-badges"
    }, _vm._l((_vm.sellerMarketplaceChips(seller)), function(mp, mpIdx) {
      return _c('span', {
        key: _vm.sellerKeyVal(seller) + '-' + mp.flag + '-' + mpIdx,
        staticClass: "ats-mp-badge"
      }, [_c('i', {
        class: mp.flag + ' flag'
      }), _vm._v(" " + _vm._s(mp.label) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('td', [(seller.mayNeedReauthorization) ? _c('span', {
      staticClass: "ats-badge ats-badge-warn"
    }, [_vm._v("Re-auth needed")]) : _c('span', {
      staticClass: "ats-badge ats-badge-ok"
    }, [_vm._v("Authorized")])]), _vm._v(" "), _c('td', {
      staticClass: "ats-cell-center"
    }, [_c('label', {
      staticClass: "ats-toggle",
      class: {
        'ats-toggle-busy': _vm.killSwitchBusy(seller)
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "aria-label": "Stop all alerts",
        "disabled": !_vm.isOwner || _vm.killSwitchBusy(seller)
      },
      domProps: {
        "checked": !_vm.sellerAlertsEnabled(seller)
      },
      on: {
        "change": function($event) {
          return _vm.onStopToggle(seller, 'alertsEnabled', $event.target.checked)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ats-toggle-slider"
    })])]), _vm._v(" "), (_vm.isOwner) ? _c('td', {
      staticClass: "ats-cell-actions"
    }, [_c('button', {
      staticClass: "ats-icon-btn",
      attrs: {
        "title": "Re-authorize"
      },
      on: {
        "click": function($event) {
          return _vm.reauthorizeSeller(seller)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 001.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "ats-icon-btn ats-icon-btn-danger",
      attrs: {
        "type": "button",
        "title": "Delete storefront",
        "disabled": _vm.deletingSellerId != null
      },
      on: {
        "click": function($event) {
          return _vm.deleteSeller(seller)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })])])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "ats-card-footer"
  }, [(_vm.isStarterPlan && !_vm.canAddStorefront) ? _c('span', {
    staticClass: "ats-note"
  }, [_vm._v("Starter plan includes up to " + _vm._s(_vm.starterMaxStorefronts) + " storefronts.")]) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('button', {
    staticClass: "ats-btn ats-btn-primary",
    class: {
      'ats-btn-loading': _vm.savingSellers
    },
    attrs: {
      "disabled": !_vm.sellersDirty
    },
    on: {
      "click": _vm.saveSellers
    }
  }, [_vm._v("Save Changes")]) : _c('p', {
    staticClass: "ats-member-readonly-hint"
  }, [_vm._v("View only — contact your account admin to add or edit storefronts.")])])]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("TEAM")]), _vm._v(" "), _c('div', {
    staticClass: "ats-card"
  }, [_c('div', {
    staticClass: "ats-card-header"
  }, [_vm._m(3), _vm._v(" "), (_vm.isOwner) ? _c('button', {
    staticClass: "ats-btn ats-btn-outline",
    on: {
      "click": _vm.inviteMember
    }
  }, [_vm._v("+ Invite Member")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ats-table-wrap"
  }, [_c('table', {
    staticClass: "ats-table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [(_vm.memberRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "ats-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No team members yet.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.memberRows), function(member) {
    return _c('tr', {
      key: 'm-' + (member.user.id != null ? member.user.id : member.user.email)
    }, [_c('td', [_c('div', {
      staticClass: "ats-member-info"
    }, [_c('span', {
      staticClass: "ats-member-name"
    }, [_vm._v(_vm._s(member.user.fullName || member.user.email))]), _vm._v(" "), _c('a', {
      staticClass: "ats-member-email",
      attrs: {
        "href": 'mailto:' + member.user.email
      }
    }, [_vm._v(_vm._s(member.user.email))])])]), _vm._v(" "), _c('td', [(_vm.memberRoleIsLocked(member)) ? _c('span', {
      staticClass: "ats-badge ats-badge-role-admin"
    }, [_vm._v(_vm._s(_vm.memberRoleBadgeLabel(member)))]) : (_vm.isOwner && member.emailAddress) ? _c('select', {
      staticClass: "ats-role-select",
      attrs: {
        "disabled": _vm.savingMemberRoleUserId != null
      },
      domProps: {
        "value": _vm.memberRoleSelectValue(member)
      },
      on: {
        "change": function($event) {
          return _vm.onMemberRoleChange(member, $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "member"
      }
    }, [_vm._v("Member")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "admin"
      }
    }, [_vm._v("Admin")])]) : (member.user.isOwner) ? _c('span', {
      staticClass: "ats-badge ats-badge-role-admin"
    }, [_vm._v(_vm._s(_vm.memberRoleBadgeLabel(member)))]) : _c('span', {
      staticClass: "ats-badge ats-badge-role-member"
    }, [_vm._v("Member")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ats-account-pills"
    }, [(member.user.isOwner) ? [_c('span', {
      staticClass: "ats-pill-account"
    }, [_vm._v("All accounts")])] : [_vm._l((_vm.memberAssignedAccounts(member)), function(acc) {
      return _c('span', {
        key: acc,
        staticClass: "ats-pill-account"
      }, [_vm._v(_vm._s(acc))])
    }), _vm._v(" "), (_vm.isOwner && !member.user.isOwner && member.emailAddress) ? _c('a', {
      staticClass: "ats-edit-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openAssignSellersModal(member)
        }
      }
    }, [_vm._v("+ Edit")]) : _vm._e()]], 2)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ats-status-cell"
    }, [(_vm.memberIsVerified(member)) ? _c('span', {
      staticClass: "ats-badge ats-badge-ok"
    }, [_vm._v("Verified")]) : _c('span', {
      staticClass: "ats-badge ats-badge-warn"
    }, [_vm._v("Not verified")]), _vm._v(" "), (_vm.showVerifyEmailButton(member)) ? _c('button', {
      staticClass: "ats-btn ats-btn-outline ats-btn-verify-email",
      class: {
        'ats-btn-loading': _vm.verificationEmailSendingId === _vm.memberVerificationButtonKey(member)
      },
      attrs: {
        "type": "button",
        "disabled": _vm.verificationEmailSendingId === _vm.memberVerificationButtonKey(member)
      },
      on: {
        "click": function($event) {
          return _vm.sendMemberVerificationEmail(member)
        }
      }
    }, [_vm._v("\n                    Resend Verification Email\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "ats-cell-actions"
    }, [(member.user.isOwner) ? _c('span', {
      staticClass: "ats-text-muted"
    }, [_vm._v("—")]) : (_vm.isOwner) ? _c('button', {
      staticClass: "ats-icon-btn ats-icon-btn-danger",
      attrs: {
        "title": "Remove member"
      },
      on: {
        "click": function($event) {
          return _vm.removeMember(member)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })])]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "ats-section-label"
  }, [_vm._v("INTEGRATIONS")]), _vm._v(" "), _c('div', {
    staticClass: "ats-integrations-grid"
  }, [_c('div', {
    staticClass: "ats-int-card"
  }, [_c('div', {
    staticClass: "ats-int-icon"
  }, [_c('img', {
    staticClass: "ats-int-logo",
    attrs: {
      "src": _vm.googleSheetsLogo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-body"
  }, [_c('span', {
    staticClass: "ats-int-name"
  }, [_vm._v("Google Sheets")]), _vm._v(" "), (_vm.gsheetsConnection.email) ? _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v(_vm._s(_vm.gsheetsConnection.email))]) : _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v("Export alerts to a spreadsheet")])]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-actions"
  }, [(_vm.gsheetsConnection.email && _vm.gsheetsConnection.email !== 'pending') ? [_c('span', {
    staticClass: "ats-badge ats-badge-ok"
  }, [_vm._v("Connected")]), _vm._v(" "), (_vm.gsheetsConnection.spreadsheetId) ? _c('a', {
    staticClass: "ats-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openGoogleSheet.apply(null, arguments)
      }
    }
  }, [_vm._v("Open →")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "ats-link ats-link-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.revokeGoogleSheets.apply(null, arguments)
      }
    }
  }, [_vm._v("Revoke")])] : _c('button', {
    staticClass: "ats-btn ats-btn-connect",
    on: {
      "click": _vm.connectGoogleSheets
    }
  }, [_vm._v("Connect")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-card"
  }, [_c('div', {
    staticClass: "ats-int-icon"
  }, [_c('img', {
    staticClass: "ats-int-logo",
    attrs: {
      "src": _vm.zapierLogo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-body"
  }, [_c('span', {
    staticClass: "ats-int-name"
  }, [_vm._v("Zapier")]), _vm._v(" "), (_vm.hasZapier) ? _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v("Connected" + _vm._s(_vm.zapierConnectedSince ? ' · ' + _vm.zapierConnectedSince : ''))]) : _c('span', {
    staticClass: "ats-int-detail"
  }, [_vm._v("Trigger Zaps from SentryKit alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "ats-int-actions"
  }, [(_vm.hasZapier) ? [_c('span', {
    staticClass: "ats-badge ats-badge-ok"
  }, [_vm._v("Connected")]), _vm._v(" "), _c('a', {
    staticClass: "ats-link",
    attrs: {
      "href": _vm.zapierTriggersDocUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Triggers →")]), _vm._v(" "), _c('a', {
    staticClass: "ats-link ats-link-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.revokeZapier.apply(null, arguments)
      }
    }
  }, [_vm._v("Revoke")])] : _c('a', {
    staticClass: "ats-btn ats-btn-connect",
    attrs: {
      "href": _vm.zapierDirectoryUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Connect")])], 2)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ats-slide-up"
    }
  }, [(_vm.successMsg) ? _c('div', {
    staticClass: "ats-toast ats-toast-ok"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ats-slide-up"
    }
  }, [(_vm.errorMsg) ? _c('div', {
    staticClass: "ats-toast ats-toast-err"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('change-password-modal', {
    ref: "changePasswordModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui modal add-storefront-modal",
    attrs: {
      "id": "addSellerAccountModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Connect Amazon storefront")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "add-storefront-modal-desc"
  }, [_vm._v("Approve SentryKit on Amazon.")]), _vm._v(" "), _c('add-seller-account', {
    attrs: {
      "show-nickname": true
    },
    on: {
      "error": _vm.onAddSellerError
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "assignSellersModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Assign storefronts")]), _vm._v(" "), (_vm.assignModalMember) ? _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "assign-modal-intro"
  }, [_vm._v("\n        Choose which connected storefronts "), _c('strong', [_vm._v(_vm._s(_vm.assignModalMember.user.fullName || _vm.assignModalMember.user.email))]), _vm._v(" can access. They only receive alerts for assigned accounts.\n      ")]), _vm._v(" "), (!_vm.sellers.length) ? _c('div', {
    staticClass: "assign-modal-empty"
  }, [_vm._v("No storefronts connected yet.")]) : _c('div', {
    staticClass: "assign-seller-list"
  }, _vm._l((_vm.sellers), function(seller) {
    return _c('label', {
      key: 'assign-seller-' + _vm.sellerIdVal(seller),
      staticClass: "assign-seller-row"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.assignModalSellerChecked(seller)
      },
      on: {
        "change": function($event) {
          return _vm.assignModalToggleSeller(seller)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "assign-seller-label"
    }, [_vm._v(_vm._s(seller.nickName || _vm.sellerKeyVal(seller)))]), _vm._v(" "), _c('span', {
      staticClass: "assign-seller-meta"
    }, [_vm._v(_vm._s(_vm.sellerKeyVal(seller)))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui button",
    attrs: {
      "type": "button",
      "disabled": _vm.savingAssignModal
    },
    on: {
      "click": _vm.confirmAssignSellersModal
    }
  }, [_vm._v("\n        " + _vm._s(_vm.savingAssignModal ? 'Saving…' : 'Done') + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "inviteMemberModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Invite team member")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "invite-modal-intro"
  }, [_vm._v("\n        We will email them an invitation. Only the account owner can add users.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "invite-modal-form"
  }, [_c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteEmail),
      expression: "inviteEmail"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "email",
      "autocomplete": "off",
      "data-lpignore": "true",
      "placeholder": "colleague@company.com"
    },
    domProps: {
      "value": (_vm.inviteEmail)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitInviteMember.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "invite-modal-name-row"
  }, [_c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("FIRST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteFirstName),
      expression: "inviteFirstName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.inviteFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteFirstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ats-field"
  }, [_c('label', {
    staticClass: "ats-field-label"
  }, [_vm._v("LAST NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inviteLastName),
      expression: "inviteLastName"
    }],
    staticClass: "ats-input",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.inviteLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inviteLastName = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui button",
    attrs: {
      "type": "button",
      "disabled": _vm.inviteSubmitting
    },
    on: {
      "click": _vm.closeInviteMemberModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    class: {
      loading: _vm.inviteSubmitting,
      disabled: _vm.inviteSubmitting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.inviteSubmitting || !_vm.inviteEmailTrimmed
    },
    on: {
      "click": _vm.submitInviteMember
    }
  }, [_vm._v("\n        Send invitation\n      ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-action-overlay-inner"
  }, [_c('div', {
    staticClass: "ats-spinner"
  }), _vm._v(" "), _c('p', {
    staticClass: "ats-action-overlay-text"
  }, [_vm._v("Removing storefront…")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-header"
  }, [_c('h2', {
    staticClass: "ats-title"
  }, [_vm._v("Account & Team")]), _vm._v(" "), _c('p', {
    staticClass: "ats-subtitle"
  }, [_vm._v("Manage your profile, connected Amazon accounts, team members, and integrations.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "ats-card-title"
  }, [_vm._v("Storefronts (Seller ID)")]), _vm._v(" "), _c('p', {
    staticClass: "ats-card-desc"
  }, [_vm._v("Each connected storefront is monitored across all its marketplaces. Adding storefronts may affect your plan cost. Stop-all-alerts and stop-backend-attributes only halt outbound alerts or ATTR scans; dashboards and watchdogs keep updating.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "ats-card-title"
  }, [_vm._v("Members & Access")]), _vm._v(" "), _c('p', {
    staticClass: "ats-card-desc"
  }, [_vm._v("Admin can configure alerts and manage all accounts. Members receive alerts for their assigned accounts only.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("MEMBER")]), _vm._v(" "), _c('th', [_vm._v("ROLE")]), _vm._v(" "), _c('th', [_vm._v("ASSIGNED ACCOUNTS")]), _vm._v(" "), _c('th', [_vm._v("STATUS")]), _vm._v(" "), _c('th', [_vm._v("ACTIONS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ats-card-footer"
  }, [_c('span', {
    staticClass: "ats-note"
  }, [_vm._v("Account assignment changes are saved when you click Done in the assignment dialog.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32ce7ad0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/AccountTeamSettings.vue
// module id = 744
// module chunks = 2